import { createSlice } from '@reduxjs/toolkit';
import { selectWeather } from '../SessionSettings/WeatherSlice'
import { selectNumStudents } from './ConfigurationOptionsSlice'
import { setIsEnabledGlobal } from './RoomModuleUtils'
import { emit } from '../websocket/websocketSlice'

const initialState = {
    chair: 'Fishbone',
    classroom: 'DefaultClass',
    front: 'whiteboardFront',
    outdoor: 'PlasteredCourt',
    messiness: 0,
    isEnabled: false,
};

const configureRoomModulesSlice = createSlice({
    name: 'roomModules',
    initialState,
    reducers: {
        setIsEnabled: (state, action) => {
            state.isEnabled = action.payload;
            setIsEnabledGlobal(action.payload);
        },
        setChair: (state, action) => { state.chair = action.payload; },
        setClassroom: (state, action) => { state.classroom = action.payload; },
        setFront: (state, action) => { state.front = action.payload; },
        setOutdoor: (state, action) => { state.outdoor = action.payload; },
        setMessiness: (state, action) => { state.messiness = action.payload; },
        loadRoomModuleOptions: (state, action) => {
            state.chair = action.payload.chair;
            state.classroom = action.payload.classroom;
            state.front = action.payload.front;
            state.outdoor = action.payload.outdoor;
            state.messiness = action.payload.messiness;
            state.isEnabled = action.payload.isEnabled;
        },
        resetDefaults: (state) => {
            Object.keys(initialState).forEach((key) => {
                state[key] = initialState[key];
            });
        },
    },
});

// Selectors to get the states from the Redux Store
export const selectChair = (state) => state.roomModules.chair;
export const selectClassroom = (state) => state.roomModules.classroom;
export const selectFront = (state) => state.roomModules.front;
export const selectOutdoor = (state) => state.roomModules.outdoor;
export const selectMessiness = (state) => state.roomModules.messiness;
export const selectIsEnabled = (state) => state.roomModules.isEnabled;

export const getRoomModulePayload = (state) => {
    const room = selectClassroom(state);
    const front = selectFront(state);
    const chairs = selectChair(state);
    const outside = selectOutdoor(state);
    const messiness = selectMessiness(state);
    const studentCount = selectNumStudents(state);
    const weatherKey = selectWeather(state);
    const weather = {
        Weather: [],
        Wetness: 0,
        Opacity: 0,
        Direction: { x: 0, y: 1, z: 0 }
    };

    // Create JSON structure
    return {
        room,
        front,
        chairs,
        outside,
        studentCount,
        messiness,
        weatherKey,
        weather,
        students: studentCount
    };
};

export const sendRoomModuleParameters = () => (dispatch, getState) => {
    const parameters = getRoomModulePayload(getState());
    emit({ type: "classChange", ...parameters });
};

export const { setChair, setClassroom, setFront, setOutdoor, setMessiness, setIsEnabled, loadRoomModuleOptions, resetDefaults } = configureRoomModulesSlice.actions;

export default configureRoomModulesSlice.reducer;
